/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Dots_LabelInputs */

const en_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 or 4+ dots`)
};

const fr_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 ou 4+ points`)
};

const de_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 oder 4+ Punkte`)
};

const it_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 o 4+ punti`)
};

const ru_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 или 4+ точек`)
};

const es_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 o 4+ puntos`)
};

const zh_cn2_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 或 4 个以上点`)
};

const ja_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つまたは4つ以上のドット`)
};

const hi_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 या 4+ बिंदु`)
};

const pt_pt2_style_guide_manager_dots_label = /** @type {(inputs: Style_Guide_Manager_Dots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 ou 4+ pontos`)
};

/**
* | output |
* | --- |
* | "2 or 4+ dots" |
*
* @param {Style_Guide_Manager_Dots_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_dots_label = /** @type {((inputs?: Style_Guide_Manager_Dots_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Dots_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_dots_label(inputs)
	if (locale === "de") return de_style_guide_manager_dots_label(inputs)
	if (locale === "it") return it_style_guide_manager_dots_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_dots_label(inputs)
	if (locale === "es") return es_style_guide_manager_dots_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_dots_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_dots_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_dots_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_dots_label(inputs)
	return en_style_guide_manager_dots_label(inputs)
});